import { z } from "zod";

import {
	PasswordStrengthValidationConfig,
	type PasswordStrengthValidation,
} from "@/features/auth/passwordStrengthValidation";

/** The fields validated by {@link createChangePasswordSchemaBase}. */
export interface ChangePasswordFormValuesBase {
	password: string;
	confirm: string;
	disconnectMobileDevices: boolean | null;
}

export function createChangePasswordSchemaBase(
	hasConnectedMobileDevices: boolean,
	passwordStrengthValidation?: PasswordStrengthValidation,
) {
	const strengthConfig = passwordStrengthValidation
		? new PasswordStrengthValidationConfig(passwordStrengthValidation)
		: null;
	return z
		.object({
			password: z
				.string()
				.min(1, { error: messages["validator.messages.required"] })
				.refine(
					(value) =>
						strengthConfig == null || strengthConfig.validate(value).isValid,
					{
						error: messages["changePassword.failure.requirementsNotMet"],
						// Don't stack the strength error on top of "required" for an empty field.
						when: (payload) =>
							typeof payload.value === "string" && payload.value.length > 0,
					},
				),
			confirm: z.string().min(1, { error: messages["validator.messages.required"] }),
			disconnectMobileDevices: z
				.boolean()
				.nullable()
				.refine((value) => !hasConnectedMobileDevices || value != null, {
					error: messages["changePassword.failure.disconnectDevices"],
				}),
		})
		.refine((value) => value.password === value.confirm, {
			path: ["confirm"],
			error: messages["changePassword.failure.passwordsDoNotMatch"],
		});
}
